import classNames from 'classnames';
import React, { ReactElement } from 'react';

import { IStyleableProps } from '../../../shared/types/IStyleableProps';

export type ISkeletonDividerProps = IStyleableProps;

export function OzSkeletonDivider (props: ISkeletonDividerProps): ReactElement {
    const {
        className = '',
    }: ISkeletonDividerProps = props;

    const dividerClassNames: string = classNames({
        'my-3': !/(mt|mb|my)/.test(className),
        [className]: !!className,
    });

    return (
        <hr className={`h-px bg-gray-100 border-none ${dividerClassNames}`} />
    );
}
